import config from '../config';
import { CONTACT_EMAIL } from './constants';

export const APP_LINKS = {
  root: '/',
  dashboard: '/dashboard',
  help: '/help',
  profile: '/profile',
  loans: '/loans',
  fundraising: '/fundraising',
  founders: '/founders',
  brands: '/brands',
  payments: '/payments',
  loanTerms: '/loan-terms',
  loanTermsPlans: (version, plan) =>
    `/loan-terms/plans${version ? `/${version}` : ''}${plan ? `?plan=${plan}` : ''}`,
  loanTermsFpg: (version, plan) =>
    `/loan-terms/fpg${version ? `/${version}` : ''}${plan ? `?plan=${plan}` : ''}`,
  loanTermsRefinancing: version => `/loan-terms/refinancing${version ? `/${version}` : ''}`,
  loanTermsFlexibility: version => `/loan-terms/flexibility${version ? `/${version}` : ''}`,
  loanTermsReportingModes: version => `/loan-terms/reporting-modes${version ? `/${version}` : ''}`,
  fpg: '/fpg',
  activity: '/activity',
  signIn: '/sign-in',
  signUp: '/sign-up',
  nextPayment: '/payments/next-payments',
  prepayLoans: '/payments/prepay-loans',
  addFunds: '/payments/add-funds',
  addFundsResult: '/payments/add-funds/result',
  withdraw: '/payments/withdraw',
  bankAccounts: '/payments/bank-accounts',
  bankAccountsCreate: '/payments/bank-accounts/new',
  bankAccountsEdit: id => `/payments/bank-accounts/${id}`,
  unsubordinatedFinancialAgreement:
    config.mainPromoDomain + '/docs/scramble_financing_agreement_unsubordinated_loans.pdf',
  subordinatedFinancialAgreement:
    config.mainPromoDomain + '/docs/scramble_financing_agreement_subordinated_loans.pdf',
  docAnnexToSubordinatedLoansAgreement:
    config.mainPromoDomain + '/docs/scramble_annex_to_subordinated_loans_agreement.pdf',
  docLoanSeveranceAgreement: config.mainPromoDomain + '/docs/LoanSeveranceAgreement_24_04.pdf',
  docAnnexToUnSubordinatedLoansAgreement:
    config.mainPromoDomain + '/docs/scramble_annex_to_unsubordinated_loans_agreement.pdf',
  docAssignmentAgreement: config.mainPromoDomain + '/docs/Assignment_Agreement_25_07.pdf',
  suretyAgreement: config.mainPromoDomain + '/docs/Founder_SuretyAgreement_25_07.pdf',
  founderPromoDomain: config.founderPromoDomain,
  howItWorks: config.investorPromoDomain + '/how-it-works',
  docPrivacyAndPolicy: config.mainPromoDomain + '/docs/Privacy_policy.pdf',
  docTermsOfUse: config.mainPromoDomain + '/docs/Terms_of_use.pdf',
  docGuideForFounders: config.mainPromoDomain + '/docs/guide_for_founders.pdf',
  contactEmail: `mailto:${CONTACT_EMAIL}`,
  startupDetail: slug => `/startups/${slug}`,
  founderDetail: id => `/founders/${id}`,
  reporting: '/reporting',
  reportingUpload: id => `/reporting-upload/${id}`,
  cashMovements: '/activity/cash-movements',
  portfolioMovements: '/activity/portfolio-movements',
  taxReport: '/activity/tax-report',
  fundraisingApplication: '/fundraising-application',
  complianceForm: id => `/compliance-form/${id}`,
};
